import { render, staticRenderFns } from "./FormHistory.vue?vue&type=template&id=7c6b4ec4&"
import script from "./FormHistory.vue?vue&type=script&lang=js&"
export * from "./FormHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports